import { useEffect, useState } from "react";
import MobileHeader from "../../../layout/DriverLayout/Header";
import { Box, Typography, useTheme } from "@mui/material";
import ArrowTickLeft from "../../../../media/images/icons/arrow-tick-left";
import TruckCheck from "../../../../media/images/icons/truck-check";
import InfoTriangle from "../../../../media/images/icons/info-triangle";
import CustomInput from "../../../components/CustomInput";
import CustomInputLabel from "../../../components/CustomInputLabel";
import { blueGrey, grey } from "@mui/material/colors";
import CustomAutoComplete from "../../../components/CustomAutoComplete";
import PelakInput from "./PelakInput";
import { useFormik } from "formik";
import CustomButton from "../../../components/CustomButton";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../services/fetcher";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../redux/features/snackbarSlice";
import { useAppDispatch } from "../../../../hooks/useRedux";
import { useNavigate } from "react-router-dom";
import {
  setDialogDescription,
  setDialogStatus,
  setDialogTitle,
  setOpenDialog,
} from "../../../../redux/features/dialogSlice";
import {
  setDriverLicensePlate,
  setloaderTypeGroup,
  setloaderTypeName,
  setSmartCart,
  setVehicleSmartCard,
} from "../../../../redux/features/userSlice";
import { PreventInputAlpha } from "../../../../utils/functions";

import * as yup from "yup";

export default function ChangeVehiclePage() {
  const [loaderTypeInputValue, setloaderTypeInputValue] = useState("");
  const [loaderTypesOptions, setloaderTypesOptions] = useState([]);

  const [pelakNoTemp, setPelakNoTemp] = useState({
    alpha: "",
    firstTowDigits: "",
    lastThiredDigits: "",
    licensePlateSerial: "",
  });

  const theme = useTheme();

  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const loaderInfoFormik = useFormik({
    initialValues: {
      smartCard: "",
    },
    validationSchema: yup.object().shape({
      smartCard: yup.string().required("این فیلد الزامی است!"),
    }),
    validateOnChange: true,
    onSubmit: (values) => {
      getLoaderInfoTrigger(values);
    },
  });

  const loaderTypeInfoFormik = useFormik({
    initialValues: {
      smartCard: loaderInfoFormik.values.smartCard || "",
      loaderType: null,
      loaderGroupName: "",
    },
    validationSchema: yup.object().shape({
      smartCard: yup.string().required("این فیلد الزامی است!"),
      loaderType: yup.object().required("این فیلد الزامی است!"),
    }),
    validateOnChange: true,
    onSubmit: (values) => {
      console.log(values);
      postEditVehicleTrigger({
        LoaderTypeCode: values.loaderType && values.loaderType["value"],
        vehicleSmartCard: values.smartCard,
      });
    },
  });

  const { trigger: setVehicleDriverTrigger } = useSWRMutation(
    [`/Driver/SetVehicleDriver`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: () => {
        getDriverbarTrigger();
      },
    }
  );

  const { trigger: getLoaderInfoTrigger, data: loaderGroupInfo } =
    useSWRMutation(
      [`/Vehicle/GetVehicleInfo`, localStorage.getItem("access_token")],
      fetcherPost,
      {
        onSuccess: (data) => {
          const { vehicle, loaderGroup } = data;

          loaderTypeInfoFormik.setFieldValue("smartCard", vehicle.smartCard);

          if (vehicle.loaderTypeName) {
            loaderTypeInfoFormik.setFieldValue("loaderType", {
              label: vehicle.loaderTypeName,
              value: vehicle.loaderTypeCode,
              group: vehicle.loaderTypeGroup | loaderGroup,
            });
            loaderTypeInfoFormik.setFieldValue("loaderGroupName", loaderGroup);
          } else {
            loaderTypeInfoFormik.setFieldValue("loaderType", null);
          }

          const firstTowDigits = vehicle.licensePlateNr.slice(4, 6);
          const lastThiredDigits = vehicle.licensePlateNr.slice(0, 3);
          const alpha = vehicle.licensePlateNr.slice(3, 4);

          setPelakNoTemp({
            alpha,
            firstTowDigits,
            lastThiredDigits,
            licensePlateSerial: vehicle.licensePlateSerial,
          });
        },
      }
    );

  const { trigger: postEditVehicleTrigger } = useSWRMutation(
    [`/Vehicle/EditVehicle`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: () => {
        dispatch(setOpenDialog(true));
        dispatch(setDialogStatus("success"));
        dispatch(setDialogTitle("اطلاعات با موفقیت ثبت شد!"));
        dispatch(setDialogDescription("...درحال انتقال به صفحه اصلی"));
        dispatch(
          setloaderTypeGroup(
            loaderTypeInfoFormik.values.loaderType
              ? loaderTypeInfoFormik.values.loaderType["group"]
              : ""
          )
        );
        dispatch(setVehicleSmartCard(loaderTypeInfoFormik.values.smartCard));
        dispatch(setDriverLicensePlate(pelakNoTemp));

        setVehicleDriverTrigger({
          input: loaderTypeInfoFormik.values.smartCard,
        });

        setTimeout(() => {
          dispatch(setOpenDialog(false));
          dispatch(setDialogDescription(""));
          navigate("../dashboard");
        }, 3000);
      },
    }
  );

  const { trigger: getLoaderTypesTrigger } = useSWRMutation(
    [`/LoaderType/SearchByName`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        setloaderTypesOptions(() =>
          data.map((item: any) => ({
            label: item.name,
            value: item.code,
          }))
        );
      },
    }
  );

  const { trigger: getVehicleInfoTrigger } = useSWRMutation(
    [`/Vehicle/GetVehicleInfo`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        const { vehicle } = data;
        if (vehicle.loaderTypeName) {
          const firstTowDigits = vehicle.licensePlateNr.slice(4, 6);
          const lastThiredDigits = vehicle.licensePlateNr.slice(0, 3);
          const alpha = vehicle.licensePlateNr.slice(3, 4);

          dispatch(
            setDriverLicensePlate({
              firstTowDigits,
              lastThiredDigits,
              alpha,
              licensePlateSerial: vehicle.licensePlateSerial,
            })
          );
          dispatch(setVehicleSmartCard(vehicle.smartCard));
        }

        if (!vehicle.smartCard) {
          navigate("complete-info");
        }
      },
    }
  );

  const { trigger: getDriverbarTrigger } = useSWRMutation(
    [`/Driver/GetDriverBar`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: async (data) => {
        const { vehicleSmartCard } = data;

        if (vehicleSmartCard) {
          dispatch(setSmartCart(vehicleSmartCard));

          try {
            const resp = await getVehicleInfoTrigger({
              smartCard: vehicleSmartCard,
            });

            const { vehicle, loaderGroup } = resp;

            const { loaderTypeName } = vehicle;

            dispatch(setloaderTypeGroup(loaderGroup));

            dispatch(setloaderTypeName(loaderTypeName));
          } catch (e) {
            console.log(e);
          }
        }
      },
    }
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      loaderTypeInputValue &&
        getLoaderTypesTrigger({
          name: loaderTypeInputValue,
        })
          .then((data) => {
            setloaderTypesOptions((prev) =>
              data.map((item: any) => ({
                label: item.name,
                value: item.code,
                group: item.group,
              }))
            );
          })
          .catch((e) => {
            console.log(e);
          });
    }, 1000);
    return () => clearTimeout(timer);
  }, [loaderTypeInputValue, getLoaderTypesTrigger]);

  const handleChangeAutoComplete = (
    selected: any,
    type: string | undefined
  ) => {
    switch (type) {
      case "loaderType":
        loaderTypeInfoFormik.setFieldValue("loaderType", selected);
        break;

      default:
        break;
    }
  };

  return (
    <>
      <MobileHeader title={HeadTitle()} />
      <Box
        sx={{
          paddingX: "8px",
          paddingY: "8px",
        }}
      >
        <Box
          sx={{
            width: "100%",
            borderColor: blueGrey[100],
            borderWidth: "1px",
            borderStyle: "solid",
            backgroundColor: "bgColor.white",
            padding: "16px",
            borderRadius: "16px",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              justifyContent: "center",
            }}
          >
            <TruckCheck color={theme.palette.primary.main} size={25} />
            <Typography
              sx={{
                color: "primary.main",
                fontSize: "16px",
                fontWeight: "700",
              }}
            >
              تغییر ناوگان
            </Typography>
          </Box>

          <Box
            sx={{
              bgcolor: theme.palette.primary[50],
              padding: "10px 12px",
              borderRadius: "12px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <InfoTriangle color={theme.palette.primary.main} />
              <Typography
                sx={{
                  fontSize: "16px",
                  color: "primary.main",
                  fontWeight: "700",
                }}
              >
                توجه:
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "primary.main",
                fontSize: "14px",
                fontWeight: "700",
              }}
            >
              در صورت تغییر ناوگان ، باید عکس مدارک خود را برای تایید احراز هویت
              ناوگان ارسال کنید.
            </Typography>
          </Box>

          <Box
            sx={{
              textAlign: "center",
            }}
          >
            <CustomInputLabel required>{"شماره کارت هوشمند"}</CustomInputLabel>

            <CustomInput
              name={"smartCard"}
              value={loaderInfoFormik.values.smartCard}
              handelChange={(e) => {
                if (e.target.value.length > 7) return;
                PreventInputAlpha(e, loaderInfoFormik.handleChange);
                PreventInputAlpha(e, loaderTypeInfoFormik.handleChange);
              }}
              error={
                (loaderInfoFormik.touched.smartCard &&
                  Boolean(loaderInfoFormik.errors.smartCard)) ||
                (loaderTypeInfoFormik.touched.smartCard &&
                  Boolean(loaderTypeInfoFormik.errors.smartCard))
              }
              errorMessage={
                loaderInfoFormik.errors.smartCard ||
                loaderTypeInfoFormik.errors.smartCard
              }
              placHolder="شماره 7 رقمی کارت هوشمند ناوگان"
              endAdornment={
                <CustomButton
                  // loading={smartCard.loading}
                  onClick={loaderInfoFormik.handleSubmit}
                  flexDirection="row"
                  title="استعلام"
                  justifyContent="center"
                  bgColor="primary.main"
                  fSize="12px"
                  px="20px"
                  py="8px"
                  borderRadius="8px"
                  // icon2={<ArrowLeftCircle size={32} />}
                />
              }
            />
          </Box>
          <hr
            style={{
              width: "100%",
              border: "1px solid",
              borderColor: grey[400],
            }}
          />
          <Box
            sx={
              {
                // border: "1px solid gray",
              }
            }
          >
            <CustomInputLabel required>{"نوع بارگیری"}</CustomInputLabel>
            <CustomAutoComplete
              inputValue={loaderTypeInputValue}
              setInputValue={setloaderTypeInputValue}
              type={"loaderType"}
              placeHolder="نوع بارگیر"
              setValue={handleChangeAutoComplete}
              value={loaderTypeInfoFormik.values.loaderType}
              error={
                loaderTypeInfoFormik.touched.loaderType &&
                Boolean(loaderTypeInfoFormik.errors.loaderType)
              }
              errorMessage={loaderTypeInfoFormik.errors.loaderType}
              options={loaderTypeInputValue ? loaderTypesOptions : []}
              // innerIcon={
              //   <LocationOutline size={18} color={theme.palette.textColor.light} />
              // }
            />
          </Box>
          {/* <Box>
            <CustomInputLabel required>{"گروه بارگیر"}</CustomInputLabel>
            <CustomAutoComplete
              // inputValue={inputValue}
              // setInputValue={setInputValue}
              // type={loaderType.autoCompleteType}
              // setValue={handleChangeAutoComplete}
              placeHolder="گروه بارگیر"

              // value={loaderType.autoCompleteSelected}
              // error={loaderType.error}
              // errorMessage={loaderType.errorMessage}
              // options={loaderType.inputValue ? loaderType.options : []}
              // innerIcon={
              //   <LocationOutline size={18} color={theme.palette.textColor.light} />
              // }
            />
          </Box> */}

          <Box>
            <CustomInputLabel>{"گروه بارگیری"}</CustomInputLabel>
            <Box
              sx={{
                backgroundColor: theme.palette.primary[50],
                textAlign: "center",
                color: "primary.main",
                padding: "16px 0px",
                borderRadius: "16px",
              }}
            >
              {loaderTypeInfoFormik.values.loaderType?.["group"] ||
                loaderGroupInfo?.loaderGroup ||
                "-------"}
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <CustomInputLabel required>{"پلاک ناوگان"}</CustomInputLabel>

            <PelakInput {...pelakNoTemp} />
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <CustomButton
              // loading={loading}
              onClick={() => navigate(-1)}
              flex={1}
              flexDirection="row"
              title="انصراف"
              justifyContent="center"
              bgColor={theme.palette.primary[50]}
              borderColor="primary.main"
              textColor="primary.main"
              fSize="16px"
              px="10px"
              py="10px"
              borderRadius="10px"
              // icon1={<CheckCircle size={32} />}
              mt="16px"
            />
            <CustomButton
              // loading={loading}
              onClick={() => loaderTypeInfoFormik.handleSubmit()}
              flex={1}
              flexDirection="row"
              title="ذخیره اطلاعات"
              justifyContent="center"
              bgColor="primary.main"
              fSize="16px"
              px="10px"
              py="10px"
              borderRadius="10px"
              // icon1={<CheckCircle size={32} />}
              mt="16px"
            />
          </Box>
        </Box>
      </Box>
    </>
  );
}

function HeadTitle() {
  const theme = useTheme();

  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Typography
        onClick={() => navigate("../profile")}
        sx={{
          cursor: "pointer",
          color: "secondary.main",
          fontWeight: 700,
        }}
      >
        حساب کاربری من{" "}
      </Typography>
      <ArrowTickLeft size={14} color={theme.palette.textColor.main} />
      <Typography
        sx={{
          color: "secondary.main",

          fontSize: "14px",
          fontWeight: 700,
        }}
      >
        تغییر ناوگان{" "}
      </Typography>
    </Box>
  );
}
